import { BaseEntity, getCachedStructureEntity } from ".";
import { IGet_corporations_corporation_id_orders_history_200_ok } from "../service/esiclient";
import { getCachedTypeEntity } from "./TypeEntityCache";
import moment from "moment";
import { getCachedStationEntity } from "./StationEntityCache";

export class CorporationOrderHistoryEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Historical Corporation Order";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_corporations_corporation_id_orders_history_200_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      //IS BUY ORDER = TRUE is not in the data for cancelled sell orders
      //Might need to add it to ensure data compatability and maybe display SELL/BUY in front of the historical data.

      if (props.issued) {
        const issued = moment(props.issued);
        entity.properties["issued"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: issued.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (!props.is_buy_order) {
        entity.properties["is_buy_order"] = {
          type: Excel.CellValueType.boolean,
          basicValue: false,
        };
      }
      if (props.location_id) {
        const stationEntity = await getCachedStationEntity(props.location_id);
        if (stationEntity !== null) {
          entity.properties["location"] = await stationEntity.toJson(true);
          delete entity.properties["location_id"];
        } else {
          const structureEntity = await getCachedStructureEntity(props.location_id, this._character_id);
          if (structureEntity !== null) {
            entity.properties["location"] = await structureEntity.toJson(true);
            delete entity.properties["location_id"];
          }
        }
      }
      // - Id
      delete entity.properties["id"];
      const item = props.type_id ? await getCachedTypeEntity(props.type_id) : null;
      const name = item !== null ? item.props["name"] : "Unknown item";
      const numberOptions = { minimumFractionDigits: 2 };
      const priceVar = props.price?.toLocaleString("en-GB", numberOptions);
      //Volume remain only counts for cancelled orders, buy orders showing remain doesn't really do anything for the user
      //since we don't get how much was purchased by the user for buy orders.
      entity.text = name + " @ " + priceVar + " ISK (" + props.volume_total + ")";
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
